import {Header, TableSkeleton} from '@/components';
import SystemHealthBanner from '@/components/SystemHealthBanner';

import ProcessorBalanceTable from './ProcessorBalanceTable';
import useProcessorBalance from './useProcessorBalance';

export default function ProcessorBalanceScreen() {
  const {balance, balanceDenomination, isLoading} = useProcessorBalance();

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title="Processor Balances" />
      <SystemHealthBanner reason="Balances are read live from each partner. If one is blank, slow or looks wrong, the system health dashboard shows whether that partner is rejecting or timing out calls right now, and whether payouts through it are still completing." />

      <section className="pt-5 md:pt-5">
        {isLoading ? (
          <TableSkeleton />
        ) : (
          <ProcessorBalanceTable
            balances={balance ?? {}}
            balanceDenomination={balanceDenomination}
          />
        )}
      </section>
    </main>
  );
}
